import React from 'react';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import { gql } from '@apollo/client';
import DatePicker from 'react-datepicker';
import { ReactComponent as PlusIcon } from '../../../assets/svg/plus-gray.svg';
import InputHeader from '../global/inputwithHeader';
import CustomDateInput from '../global/customDateInput';
import _, { forEach } from 'lodash';
// import LoadingBar from '../../../components/global/loadingBar';
//import { ReactComponent as MoreVerticalIcon } from '../../../../assets/svg/Project/more-vertical.svg';
// import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
// import { ReactComponent as MinusIcon } from '../../../../assets/svg/Project/minus-circle.svg';
// import { ReactComponent as PlusIcon } from '../../../../assets/svg/plus-gray.svg';
import { withRouter } from '../../../services/withRoute';
// import 'react-datepicker/dist/react-datepicker.css';
// import InputHeader from '../../global/inputwithHeader';
// import CustomDateInput from '../../global/customDateInput';
//import CreatableSelect from 'react-select/creatable';
import Modal from '../../components/modals';
import Select from 'react-select';

import jwt_decode from 'jwt-decode';

import moment from 'moment';
const updateAsset = gql`
	mutation UpdateAsset($identifier: ID!, $updateAssetInput: UpdateAssetInput) {
		updateAsset(identifier: $identifier, updateAssetInput: $updateAssetInput) {
			id
		}
	}
`;
const getAssets = gql`
	query Assets($filters: AssetsFilters!) {
		assets(filters: $filters) {
			data {
				type
				serialNumber
				qrCode
				id
				employees {
					_id
					name
					designation
					dp_signed_url
				}
				branch {
					_id
					branchId
				}
				status
				updatedAt
				allocatedAt
			}
			hasNextPage
			hasPrevPage
			limit
			nextPage
			prevPage
			totalDocs
			totalPages
			currentPage
		}
	}
`;
class EditAsset extends ProjectsGraphQlController {
	constructor(props) {
		super(props);
		this.state = {
			statusOptions: [
				{ value: 'active', label: 'ACTIVE' },
				{ value: 'inactive', label: 'INACTIVE' },
				{ value: 'damaged', label: 'DAMAGED' },
			],

			selectedbranch: null,
			status: '',

			selectedstatus: null,
			assignedTo: '',
			selectedassignedTo: null,
		};
	}
	handleCloseModal = () => {
		this.props.handleClose();
	};
	handleEventChange = (e, name) => {
		this.setState({
			[name]: e.value,
			[`selected${name}`]: e,
		});
	};
	isDisabled = () => {
		return (
			this.state.selectedstatus === null &&
			this.state.selectedassignedTo === null &&
			this.state.selectedbranch === null
		);
	};
	editAssetApiCall = () => {
		let json = {
			identifier: this.props.modalData.id,
		};
		if (this.state.selectedbranch !== null) {
			json = {
				...json,
				updateAssetInput: {
					...json.updateAssetInput,
					branch: {
						_id: this.state.selectedbranch.value,
						branchId: this.state.selectedbranch.label,
					},
				},
			};
		}
		if (this.state.selectedassignedTo !== null) {
			json = {
				...json,
				updateAssetInput: {
					...json.updateAssetInput,
					employee: {
						_id: this.state.selectedassignedTo.value,
						name: this.state.selectedassignedTo.label,
					},
				},
			};
		}
		if (this.state.selectedstatus !== null) {
			json = {
				...json,
				updateAssetInput: {
					...json.updateAssetInput,
					status: this.state.selectedstatus.value,
				},
			};
		}
		this.updateAsset(updateAsset, json)
			.then(() => {
				this.handleCloseModal();
			})
			.then(() => {
				window.location.reload();
			});
	};
	render() {
		console.log(
			'checking props data =====> modaldata',
			this.props.modalData,
			'selecteddata====>',
			this.state.selectedbranch,
			this.state.selectedassignedTo,
			this.state.selectedstatus,
		);
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'right-add'}
				custClass={_.has(this.props, 'custClass') ? this.props.custClass : ''}
			>
				<div className="project-add-edit-popup edit-shoot-details">
					<div
						className="project-add-edit-popup-header"
						style={{
							alignItems: this.props.activeShootID == null ? 'center' : 'flex-start',
							flexDirection: this.props.activeShootID == null ? 'row' : 'column',
							height: this.props.activeShootID == null ? '56px' : '70px',
						}}
					>
						<span className="header-title">Edit Asset</span>
					</div>

					<div className="project-add-edit-popup-body">
						<div className="project-add-edit-popup-body-item" id={'details'}>
							<div className="popup-body-title">ASSET DETAILS</div>

							<div className="floating-select-container"></div>

							<InputHeader
								type="text"
								name="Type"
								value={this.props.modalData.type}
								readOnly={true}
								onChange={(e) => {}}
								isInputError={false}
								label="Type"
							/>
							<InputHeader
								type="text"
								name="serialNumber"
								value={this.props.modalData.serialNumber}
								readOnly={true}
								onChange={(e) => {}}
								isInputError={false}
								label="Serial Number"
							/>
							<InputHeader
								type="text"
								name="qrCode"
								value={this.props.modalData.qrCode}
								readOnly={true}
								onChange={(e) => {}}
								isInputError={false}
								label="QR Code"
							/>
							<div className="floating-select-container">
								<label>Assigned To</label>
								<Select
									className="cost-select-container zIndex31 w-100p"
									classNamePrefix="cost-select"
									options={this.props.assignedToOptions}
									onChange={(e) => this.handleEventChange(e, 'assignedTo')}
									defaultValue={this.props.modalData.assignedTo}
									isSearchable={true}
									// menuPortalTarget={document.body}
									menuPosition={'fixed'}
									// onMenuScrollToBottom={(e) => this.fetchMoreOptions()}
								/>
							</div>
							<div className="floating-select-container">
								<label>Status</label>
								<Select
									className="cost-select-container zIndex30 w-100p"
									classNamePrefix="cost-select"
									options={this.state.statusOptions}
									onChange={(e) => this.handleEventChange(e, 'status')}
									defaultValue={this.props.modalData.status}
									isSearchable={true}
									// onMenuScrollToBottom={(e) => this.fetchMoreOptions()}
								/>
							</div>

							<div className="floating-select-container">
								<label>Branches</label>
								<Select
									className="cost-select-container zIndex3 w-100p"
									classNamePrefix="cost-select"
									options={this.props.branchesOptions}
									onChange={(e) => this.handleEventChange(e, 'branch')}
									defaultValue={this.props.modalData.branchOption}
									isSearchable={true}
									// onMenuScrollToBottom={(e) => this.fetchMoreOptions()}
								/>
							</div>
						</div>
					</div>

					<div className="bottom-popup-action-container">
						<span className="cancel-btn" onClick={() => this.handleCloseModal()}>
							Cancel
						</span>

						<span
							className={this.isDisabled() ? 'add-edit-btn disabled' : 'add-edit-btn'}
							onClick={(e) => {
								// this.editAssetApiCall();
								if (!this.isDisabled()) {
									this.editAssetApiCall();
								}
							}}
						>
							<span>Save</span>
						</span>
					</div>
				</div>
			</Modal>
		);
	}
}
export default withRouter(EditAsset);
